import { Box } from "@mui/material";

const SkeletonLoaderCard = ({ numOfCards = 1, heightNum }: any) => {
  return (
    <>
      {numOfCards > 1 ? (
        Array.from(Array(numOfCards), (e, i) => {
          return (
            <Box
              key={i}
              className="skeleton skeleton-card"
              sx={{ height: heightNum }}
            ></Box>
          );
        })
      ) : (
        <Box
          className="skeleton skeleton-card"
          sx={{ height: heightNum }}
        ></Box>
      )}
    </>
  );
};
export default SkeletonLoaderCard;
